import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

class WeekdaysApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetAll() {
        const { data } = await this.httpClient.get(`/days`);
        return data;
    }
}

export default WeekdaysApi;